export default __webpack_public_path__ + "static/media/Standard13.a9e17303.png";